import { render, staticRenderFns } from "./PrintPosDteLetter.vue?vue&type=template&id=60da5e7a"
import script from "./PrintPosDteLetter.vue?vue&type=script&lang=js"
export * from "./PrintPosDteLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports